import React, { useCallback, useMemo, useState } from 'react'
import { Grid, Icon, Loader } from 'semantic-ui-react'
import InputField from '../formComponents/inputField'
import DropDown from '../formComponents/dropDown'
import { useDispatch, useSelector } from 'react-redux'
import { ImportShipment } from '../../containers/importShipment'
import { saveCostTypeField } from './actions/ValueBuildUp'
import { useCurrentShipmentType } from '../../hooks/useCurrentShipmentType'
const CostTypeForm = ({
  item: { costTypeId = 'costType', euroValue, costType, amount, currency, exchangeRate, custValue, statValue },
  deleteData,
  updateData,
  isFormDisabled,
  DropDownReducer = 'DropDownValues',
  translate,
}) => {
  const dispatch = useDispatch()
  const CurrencyCodes = useSelector((state) => state[DropDownReducer]?.currencyCodes)

  const { isImportShipment } = useCurrentShipmentType()
  const costTypes =
    useSelector(
      (state) => state[DropDownReducer][isImportShipment ? 'costType' : 'costTypeExport']
    ) || []
    
  const [isRemoving, setIsRemoving] = useState(false)
  const updateRemovingStatus = useCallback(() => {
    setIsRemoving(false)
  }, [isRemoving])

  let isInv = costType === 'INV'
  return (
    <Grid.Row className='vbu'>
      <Grid.Column width='3' className='divFormFeild border-bottom  b-rw-0'>
        <DropDown
          id={`costType${costTypeId}`}
          label={translate('COST_TYPE', { ns: ['default', 'valueBuildUp'] })}
          disabled={isFormDisabled || isInv}
          className='field-bg dropdown100'
          labelClass='text-none'
          isLabel={true}
          data={costTypes}
          value={costType}
          text={costType}
          clearable
          onChange={(value) => {
            updateData(costTypeId, { costType: value })
            dispatch(saveCostTypeField(costTypeId, ['costType']))
          }}
        />
      </Grid.Column>
      <Grid.Column width='2' className='divFormFeild border-bottom b-rw-0'>
        <InputField
          isLabel={false}
          id={`amount${costTypeId}`}
          type='number'
          label={translate('AMOUNT', { ns: ['default', 'valueBuildUp'] })}
          value={amount}
          addThousandsSeperator={true}
          className={'field-bg'}
          clearInput={false}
          onChange={(value) => {
            updateData(costTypeId, { amount: value })
          }}
          onBlur={(value) => {
            dispatch(saveCostTypeField(costTypeId, ['amount', 'exchangeRate']))
          }}
          disabled={isFormDisabled || isInv}
        />
      </Grid.Column>
      <Grid.Column width='2' className='divFormFeild border-bottom b-rw-0'>
        <DropDown
          id={`currency${costTypeId}`}
          label={translate('CURRENCY', { ns: ['default', 'valueBuildUp'] })}
          disabled={isFormDisabled || isInv}
          className='field-bg dropdown100'
          labelClass='text-none'
          isLabel={true}
          data={CurrencyCodes}
          value={currency}
          text={currency}
          clearable
          onChange={(value) => {
            updateData(costTypeId, { currency: value }),
              dispatch(saveCostTypeField(costTypeId, ['amount', 'currency']))
          }}
        />
      </Grid.Column>
      <Grid.Column width='2' className='divFormFeild border-bottom b-rw-0'>
        <InputField
          isLabel={false}
          id={`exhgRate${costTypeId}`}
          type='text'
          label={translate('EXCHANGE_RATE', { ns: ['default', 'valueBuildUp'] })}
          value={exchangeRate}
          className={'field-bg'}
          clearInput={false}
          onChange={(value) => {
            updateData(costTypeId, { exchangeRate: value })
          }}
          onBlur={(value) => {
            updateData(costTypeId, { exchangeRate: value })
            dispatch(saveCostTypeField(costTypeId, ['amount', 'exchangeRate']))
          }}
          disabled={isFormDisabled || isInv}
        />
      </Grid.Column>
      <Grid.Column width='2' className='divFormFeild border-bottom'>
        <InputField
          isLabel={false}
          id={`eurVal${costTypeId}`}
          type='text'
          label={translate('EUR_VALUE', { ns: ['default', 'valueBuildUp'] })}
          value={euroValue}
          addThousandsSeperator={true}
          className={'field-bg'}
          clearInput={false}
          onChange={(value) => updateData(costTypeId, { euroValue: value })}
          onBlur={(value) => {
            dispatch(saveCostTypeField(costTypeId, ['euroValue']))
          }}
          disabled={true}
        />
      </Grid.Column>
      <ImportShipment>
        <Grid.Column width='2' className={`divFormFeild border-bottom b-rw-0`}>
          <InputField
            isLabel={false}
            id={`custVal${costTypeId}`}
            type='text'
            label={translate('CUST_VALUE', { ns: ['default', 'valueBuildUp'] })}
            value={custValue}
            // className={'field-bg'}
            inputClassName={`${(Number(custValue) < 0 && 'negative-input-value') ||
              (Number(custValue) > 0 && 'positive-input-value')
              }`}
            labelClassName={`${custValue && Number(custValue) !== 0 && 'label'}`}
            className={`${Number(custValue) !== 0 && 'label'}`}
            clearInput={false}
            onChange={(value) => updateData(costTypeId, { custValue: value })}
            onBlur={(value) => {
              dispatch(saveCostTypeField(costTypeId, ['custValue']))
            }}
            disabled={true}
          />
        </Grid.Column>
      </ImportShipment>
      <Grid.Column
        width='2'
        className={`divFormFeild border-bottom 
      
          `}
      >
        <InputField
          isLabel={false}
          id={`statVal${costTypeId}`}
          type='text'
          label={translate('STAT_VALUE', { ns: ['default', 'valueBuildUp'] })}
          value={statValue}
          // className={'field-bg'}
          clearInput={false}
          inputClassName={`${(Number(statValue) < 0 && 'negative-input-value') ||
            (Number(statValue) > 0 && 'positive-input-value')
            }`}
          labelClassName={`${statValue && Number(statValue) !== 0 && 'label'}`}
          className={`${Number(statValue) !== 0 && 'label vbu-input'}`}
          disabled={true}
          onChange={(value) => updateData(costTypeId, { statValue: value })}
          onBlur={(value) => {
            dispatch(saveCostTypeField(costTypeId, ['statValue']))
          }}
        />
      </Grid.Column>
      <Grid.Column width='1' className='icon-delete-add-info'>
        {!isRemoving ? (
          <span>
            <Icon
              name='trash alternate outline'
              id={`deleteCostType-${costTypeId}`}
              onClick={() => {
                setIsRemoving(true)
                deleteData(costTypeId, updateRemovingStatus)
              }}
              disabled={isFormDisabled || isRemoving}
            />
          </span>
        ) : (
          <span className='delete-info-loader'>
            <Loader active inline size='mini' style={{ marginRight: '10px' }} />
          </span>
        )}
      </Grid.Column>
    </Grid.Row>
  )
}

export default React.memo(CostTypeForm)
